export const WIDTH_SHORT = 20;
